export class Perfil {
  url: string;
  id_empresa: number;
  id_segmento?: any;
  nome_fantasia: string;
  razao_social: string;
  cnpj: string;
  telefone: string;
  latitude: number;
  longitude: number;
  cidade: string;
  estado: string;
  endereco: string;
  bairro: string;
  complemento?: any;
  cep: string;
  numero: string;
  imagem: string;
  id_usuarios: number;
  data_cadastro: Date;
  painel_web: boolean;
}
